import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface IPosition {
  displayName: string;
  key: string;
  name: string;
}

interface IPermissionsDto {
  actions: string[];
  accessToken: string | null;
  accessTokenExpireIn: string | null;
  currentPositionKey: string | null;
  positions: IPosition[];
}

interface IPermissions {
  actions: string[];
  accessToken: string | null;
  accessTokenExpireIn: string | null;
  currentPositionKey: string | null;
  positions: IPosition[];
}

const initialState: IPermissions = {
  actions: [],
  accessToken: null,
  accessTokenExpireIn: null,
  currentPositionKey: null,
  positions: [],
};

const PermissionsSlice = createSlice({
  name: "Permissions",
  initialState,
  reducers: {
    setPermission(state: IPermissions, action: PayloadAction<IPermissionsDto>) {
      state.accessToken = action.payload.accessToken;
      state.accessTokenExpireIn = action.payload.accessTokenExpireIn;
      state.actions = action.payload.actions;
      state.currentPositionKey = action.payload.currentPositionKey;
      state.positions = action.payload.positions;
    },
    removePermissions(state: IPermissions) {
      state.accessToken = null;
      state.accessTokenExpireIn = null;
      state.actions = [];
      state.currentPositionKey = null;
      state.positions = [];
    },
  },
  extraReducers: {},
});

export const { setPermission, removePermissions } = PermissionsSlice.actions;
export default PermissionsSlice.reducer;
export type { IPosition, IPermissions };
